import React from "react";

const useSafeSetState = initialState => {
  const is_mounted = React.useRef(null);
  const [state, setState] = React.useState(initialState);
  const safeSetState = (...args) => {
    if (is_mounted.current) {
      setState(...args);
    }
  };
  React.useEffect(() => {
    is_mounted.current = true;
    return () => {
      is_mounted.current = false;
    };
  });

  return [state, safeSetState];
};

export default useSafeSetState;
